<template>

  <v-container fluid v-if="contracts">

    <im-page-title
      title="Contracte"
    />

    <im-contracts-tool
      @create="goToCreate()"
    />

    <im-contracts-list
      :contracts="contracts"
      @edit="goToEdit"
      @list="getContracts"
    />

  </v-container>

  <v-container v-else fluid class="fill-height">
    <v-row align="center" justify="center">
      <v-progress-circular indeterminate color="primary"/>
    </v-row>
  </v-container>

</template>

<script>

  import contract_repository from '@/repositories/contract-repository';

  export default {

    components: {
      'im-page-title': () => import('@/components/ThePageTitle'),
      'im-contracts-tool': () => import('@/components/Contract/ContractToolbar'),
      'im-contracts-list': () => import('@/components/Contract/ContractList')
    },

    data: () => ({
      contracts: null,
    }),

    async created() {
      this.contracts = await this.getContracts();
    },

    methods: {

      async getContracts(pagination) {
        return contract_repository.getContracts(null, pagination || {size: 10, page: 1}, {hotel: this.$route.params.hotel});
      },

      goToCreate() {
        this.$router.push(`/hotels/${this.$route.params.hotel}/contracts/create`);
      },

      goToEdit(contract) {
        this.$router.push(`/hotels/${this.$route.params.hotel}/contracts/${contract.id}`);
      }

    }

  }

</script>